<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <Table
        :fields="fields"
        :items="list"
        type="List"
        :loading="loading"
        :limit="limit"
        :setLimit="setLimit"
        :page="page"
        :setPage="setPage"
        :search="search"
        :gSearch="gSearch"
        :filtered="filtered"
        :actions="actions"
        :actionEvent="actionEvent"
        :eventBtn="eventBtn"
        />
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import i18n from '@/plugins/i18n';
    import Modals from './modals/';
    import Table from "@/components/Table"; 

    let breadCrumb = [
        { label: i18n.t('pages.defination.name'), url: "/Defination" },
        { label: i18n.t('pages.defination.vacation'), url: "/Defination/Vacations" },
    ];
    let fields = [
        { key: "name", label: i18n.t('defination.vacation.list.name'), keys: ["name"] },
        { key: "status_icon", label: i18n.t('defination.vacation.list.is_every_year'), keys: ["is_every_year"] },
        { key: "begin_date", label: i18n.t('defination.vacation.list.begin_date'), keys: ["begin_date"], type:"date" },
        { key: "end_date", label: i18n.t('defination.vacation.list.end_date'), keys: ["end_date"], type:"date" },
        { key: "actions", label: i18n.t('defination.vacation.list.actions'), keys: ["actions"] }
        ];
    export default {
        name: "Vacations",
        data: function(){
            return{
                breadCrumb,
                modalOpen: false,
                modalProps: {},
                currentForm:"Vacations",
                modalName: "",
                fields,
                limit: 10,
                page: 1,
                offset: 0,
                dismissCountDown: 0,
                params: {
                    limit: 10,
                    offset: 0
                },
                filtered: [
                    "name",
                    "begin_date",
                    "end_date",
                    "status_icon",
                    "actions"
                ],
                actions: [
                    { key: "edit", text: i18n.t('general.edit') },
                    { key: "delete", text: i18n.t('general.delete') },
                    { key: "viewJobs", text: i18n.t('defination.vacation.list.view_jobs') },
                ]
            }
        },
        async created() {
            await this.$store.dispatch("listVacations");
        },
        components:{
            BreadCrumb, Modals, Table
        },
        methods:{
            search(){
            
            },
            gSearch(data){
            
            },
            setLimit: function(limit) {
            this.limit = limit;
            this.$store.dispatch("listVacations", this.params);
            },
            setPage: function(page) {
            if (page > 0) {
                this.page = page;
                this.offset = (page - 1) * this.limit;
                this.$store.dispatch("listVacations", this.params);
            }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                this.modalProps = props
                this.modalName = modal
            },
            actionEvent: async function(key, data) {
            switch (key) {
                case "edit":
                this.openModal(true, "edit", data);
                break;
                case "delete":
                this.openModal(true, "delete", data);
                break;
                case "add":
                this.openModal(true, "add");
                break;
                case "viewJobs":
                this.$router.push( { path: '/Defination/Vacations/'+data.id+'/Jobs' })
                break;
            }
            },
        },
        computed:{
        loading() {
            return this.$store.getters.getDefinationLoading;
        },
        list() {
            return this.$store.getters.getVacations;
        },
        eventBtn(){
            return {
                text:i18n.t('general.add'),
                clicked:()=>{
                this.actionEvent("add");
                }
            }
        }
        }
    }
</script>

<style lang="css" scoped > 
    @import "./styles/signalGroups.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Defination/Vacations.vue